"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PathDetails;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _getContentTypeNames = _interopRequireDefault(require("../utils/getContentTypeNames"));

var _contentType = _interopRequireDefault(require("../utils/contentType"));

var s = {
  pathInfo: function pathInfo(theme) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("font-size:12px;color:", theme.color.dark.iron, ";overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;margin-right:-1px;")
    );
  }
};

function PathDetails(props) {
  var theme = props.theme,
      pathInfo = props.pathInfo,
      contentType = props.contentType,
      alternateContentType = props.alternateContentType;

  if (contentType !== _contentType.default.Path || !pathInfo) {
    return null;
  }

  var courses = pathInfo.courses,
      checkpoints = pathInfo.checkpoints,
      ilts = pathInfo.ilts;
  var pathElements = [];
  courses > 0 && pathElements.push("".concat(courses, " ").concat((0, _getContentTypeNames.default)(alternateContentType, 'course', 'C', {
    plural: courses > 1
  })));
  checkpoints > 0 && pathElements.push("".concat(checkpoints, " ").concat((0, _getContentTypeNames.default)(alternateContentType, 'checkpoint', 'C', {
    plural: checkpoints > 1
  })));
  ilts > 0 && pathElements.push("".concat(ilts, " ").concat((0, _getContentTypeNames.default)(alternateContentType, 'ilt', 'C', {
    plural: ilts > 1
  })));
  return _react.default.createElement("div", {
    className: s.pathInfo(theme)
  }, pathElements.join(' + '));
}